/**
 * Shared corridor bounds for the arcade flight volume and infinite grids.
 * Floor grid sits at CORRIDOR_FLOOR_Y; ceiling grid at CORRIDOR_CEILING_Y.
 *
 * Ceiling stays high enough that the chase camera (≈ ship.y + 10) sits
 * under it; ship climb is limited separately via SHIP_CLEARANCE_CEILING_Y.
 */
export const CORRIDOR_FLOOR_Y = 0;
export const CORRIDOR_CEILING_Y = 30;
export const SHIP_BASE_Y = 15;
export const SHIP_CLEARANCE_FLOOR_Y = 3.25;
/** Keeps the craft well below the upper grid (tighter than the old ±12 band). */
export const SHIP_CLEARANCE_CEILING_Y = 12;
export const SHIP_Y_MIN = CORRIDOR_FLOOR_Y + SHIP_CLEARANCE_FLOOR_Y;
export const SHIP_Y_MAX = CORRIDOR_CEILING_Y - SHIP_CLEARANCE_CEILING_Y;
